import ActionButton from "@/components/Button/ActionButton";
import { Text } from "@/components/Typography/Text";

interface SelectedOptionChipProps {
  value: string;
  label: string;
  onSelect: (value: string) => void;
}

/**
 * 選択済みのオプションを表示するチップコンポーネント
 */
export default function SelectedOptionChip({
  value,
  label,
  onSelect,
}: SelectedOptionChipProps) {
  return (
    <div className="flex items-center gap-1 rounded-md bg-muted p-2 max-w-full">
      <Text variant="labelSmallReg" className="text-wrapper">
        {label}
      </Text>
      <ActionButton
        onClick={() => onSelect(value)}
        icon="XIcon"
        iconColor="active"
        variant="ghost"
        size="sm"
        className="size-fit p-0"
      />
    </div>
  );
}
